import { Signal } from '@angular/core';

export abstract class AppContext {
  abstract readonly ready: Signal<boolean>;

  /**
   * Imperatively loads the app-specific context (e.g. contractor / corporate / facility
   * profile) required for the app to operate.
   *
   * Called by `refreshAccount` during bootstrap AFTER the auth state has been
   * populated, so implementations can read the auth state synchronously and trigger
   * the necessary API call without relying on signal → observable effect flushing
   * (which is not guaranteed to have happened yet during `provideAppInitializer`).
   *
   * Resolves once the context data is loaded, or immediately if there is nothing
   * to load (e.g. the user does not have the relevant identifier for this app).
   * Should not reject for missing identifiers — only for unexpected failures.
   */
  abstract ensureLoaded(): Promise<void>;
}
